import type { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Provider } from '@vgtv/api-client';

import { DropdownMenu } from '../DropdownMenu/DropdownMenu';
import { config } from '../../../config';
import { getPath, routeNames } from '../../../shared/helpers/routes';
import { getHomepageSlug } from '../../../shared/helpers/getHomepageSlug';
import { trackNavigationClick } from '../../../shared/helpers/trackingHelpers';
import type { MenuItems } from '../helpers';

import * as styles from './DesktopNavigation.module.scss';

const abHomeData = {
  label: 'Hem',
  link: getPath(routeNames.custom, {
    slug: getHomepageSlug(config.provider),
  }),
  id: getHomepageSlug(config.provider),
  type: 'CustomPage',
};

interface Props extends MenuItems {
  className?: string;
}

export const DesktopNavigation: FC<Props> = ({
  mainMenuItems,
  subMenuItems,
  className,
}) => {
  const { t } = useTranslation();
  const isAb = config.provider === Provider.AB;

  return (
    <nav className={className}>
      <ul className={styles.menu}>
        {isAb && (
          <li>
            <NavLink
              to={abHomeData.link}
              className={styles.menuItemContent}
              activeClassName={styles.menuItemContentActive}
              onClick={() => trackNavigationClick(abHomeData)}
            >
              {abHomeData.label}
            </NavLink>
          </li>
        )}
        {mainMenuItems.map(({ label, link, id, type }, index) => (
          <li key={index}>
            <NavLink
              to={link!}
              className={styles.menuItemContent}
              activeClassName={styles.menuItemContentActive}
              onClick={() => trackNavigationClick({ label, link, id, type })}
            >
              {label}
            </NavLink>
          </li>
        ))}
        {subMenuItems.length > 0 && (
          <li>
            <DropdownMenu
              label={t('More')}
              items={subMenuItems}
              labelClassName={styles.subMenuItemContent}
            />
          </li>
        )}
      </ul>
    </nav>
  );
};
